import {
  MapPinLine,
  Phone,
  At,
  FacebookLogo,
  LinkedinLogo
  
  
} from "@phosphor-icons/react";

export const footerData = [
  {
    footerIcon: <MapPinLine size={30} />,
    footerDesc:
   
      "Résidence Yaye Diè, N° B113, Maristes 1. 11500 DAKAR - SENEGAL",
      id :"1"
  },
  {
    footerIcon: <Phone size={30} />,
    footerDesc:
      "+221338322070 +221778745995",
        id :"2"
  },
  {
    footerIcon: <At size={30} />,
    footerDesc:
      "contact@gs7solutions.com",
        id :"3"
  },
  
  {
    footerIcon: <FacebookLogo size={25} className=" cursor-pointer hover:translate-y-[-5px] duration-300" />,
    footerDesc: "",
      id :"4"
     
  },
  {
    footerIcon: <LinkedinLogo size={25} className=" cursor-pointer hover:translate-y-[-5px] duration-300" />,
    footerDesc:"https://www.linkedin.com/company/gs7s---d%C3%A9fense-&-s%C3%A9curit%C3%A9/",
      id :"5"
     
  },


  
];
